/* eslint-disable max-len */
const AQ_INPUT_PROPS = {
    disable: { type: Boolean, default: false },
    type: { type: String, default: "text" },
    dense: { type: Boolean, default: true },
    value: { type: [Number, String], default: "" },
    stackLabel: { type: Boolean, default: false },
    label: { type: String, default: undefined },
    height: { type: Number, default: 56 },
    clearable: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    prefix: { type: null },
    suffix: { type: null },
    tabIndex: { type: Number, default: -1 },
    autocomplete: { type: String, default: "" },
    maxlength: { type: Number },
    placeholder: { type: String, default: "" },
    autofocus: { type: Boolean, default: false },
    // new
    atId: { type: String, default: "" },
    hasPrepend: { type: Boolean, default: false },
    hasAppend: { type: Boolean, default: false },
    hasBefore: { type: Boolean, default: false },
    hasAfter: { type: Boolean, default: false },
    hint: { type: String, default: "" },
    hideHint: { type: Boolean, default: false },
    name: { type: String, default: "" },
    hasNormalState: { type: Boolean, default: false }, // prop used for disable state, to look normal, but disabled
    mask: { type: String, default: "" },
    forForm: { type: String }, // don't add default "", will interfere with autofocus prop
    fillMask: { type: [Boolean, String] },
    reverseFillMask: { type: Boolean, default: false },
    unmaskedValue: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    reactiveRules: { type: Boolean, default: false },
    lazyRules: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    noErrorIcon: { type: Boolean, default: true },
    errorMessage: { type: String, default: "" },
    clearValue: { type: String, default: "" },
    clearIcon: { type: String, default: "clear" },
    shadowText: { type: String, default: "" },
    counter: { type: Boolean, default: false },
    autogrow: { type: Boolean, default: false },
    fixedAreaHeight: { type: Boolean, default: false },
    rows: { type: String, default: "" },
    debounce: { type: [String, Number] },
    //  style
    labelColor: { type: String, default: "" },
    color: { type: String, default: "" },
    bgColor: { type: String, default: "" },
    dark: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    rounded: { type: Boolean, default: false },
    square: { type: Boolean, default: false },
    itemAligned: { type: Boolean, default: false },
    borderless: { type: Boolean, default: false },
    hideBottomSpace: { type: Boolean, default: true },
    searchIconContainer: { type: Boolean, default: false },
    inputClass: { type: [Array, String, Object] },
    inputStyle: { type: [Array, String, Object] },
    standout: { type: [String, Boolean] },
    labelSlot: { type: Boolean, default: false },
    bottomSlots: { type: Boolean, default: false },
    passwordVisibility: { type: Boolean, default: true },
    dateIconDisplay: { type: Boolean, default: false },
    searchInput: { type: Boolean, default: false },
    staticBadge: { type: String, default: "" },
    primaryInput: { type: Boolean, default: false }
};
export default AQ_INPUT_PROPS;
